import { useQuery } from "@tanstack/react-query";
import { useCallback } from "react";
import useApi from "../api";
import { CustomError } from "../errors";
import { Me, UpdateLanguage } from "./type";

export const useMeApi = () => {
  const api = useApi();

  const baseUrl = "/me";

  const useSettings = useCallback(() => {
    const url = baseUrl + "/settings";
    const result = useQuery<Me, CustomError>({
      queryKey: [url],
      queryFn: ({ signal }) => api.get<Me>({ url, signal }),
    });
    return { ...result, error: result.error ?? undefined };
  }, [api]);

  const updateMyLanguage = useCallback(
    async (updateLanguage: UpdateLanguage) => {
      const data = await api.put<UpdateLanguage>(baseUrl + "/language", updateLanguage);
      api.mutateCache([baseUrl + "/language"]);
      return data;
    },
    [api]
  );

  return { useSettings, updateMyLanguage };
};
